import ContentArea from 'components/Section/ContentArea'

export default function Page({ page }) {
  return (
    <div>
      <h1>{page.title}</h1>
      <ContentArea section={{ content: page.content }} />
    </div>
  )
}
